import PropTypes from 'prop-types';

const Alert = ({ type, message }) => {
  let className = 'is-info';
  switch (type) {
    case 'error':
      className = 'is-danger';
      break;

    case 'warning':
      className = 'is-warning';
      break;

    case 'success':
      className = 'is-success';
      break;

    case 'info':
      className = 'is-info';
      break;

    default:
      break;
  }
  return (
    <div className={`message ${className}`}>
      <div className="message-body">{message}</div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Alert;
